import type { WorldBoxDto } from 'cadenza/api-client/dto/world-box-dto';
import type { ViewId } from 'cadenza/workbook/api/view-id';
import type { WorkbookId } from 'cadenza/workbook/api/workbook-id';
import { cadenzaSessionStorage } from 'cadenza/utils/session-storage/session-storage';

/**
 * Save mapExtent for given map view in sessionStorage.
 *
 * @param workbookId - the id of the workbook
 * @param viewId - viewId for map view
 * @param extent - Extent of the map view
 */
export function saveExtentToSession (workbookId: WorkbookId, viewId: ViewId, extent: WorldBoxDto): void {
  cadenzaSessionStorage.setItem(_extentSessionKey(workbookId, viewId), JSON.stringify(extent));
}

/**
 *  Loads mapExtent for given workbookId and viewId from sessionStorage
 *
 * @param workbookId - the id of the workbook
 * @param viewId - viewId for map view
 * @return Extent of the map view or null
 */
export function loadExtentFromSession (workbookId: WorkbookId, viewId: ViewId): WorldBoxDto | null {
  const item = cadenzaSessionStorage.getItem(_extentSessionKey(workbookId, viewId));
  return item != null ? JSON.parse(item) : null;
}

function _extentSessionKey (workbookId: WorkbookId, viewId: ViewId): string {
  return `mapState.${workbookId}.${viewId}.extent`;
}

// If this is set, a toast message is shown to the user on initializing the workbook.
export const USER_MESSAGE_STORAGE_KEY = 'd-workbook.init-toast-message';
